import { schema } from 'normalizr';

export const notificationSchema = new schema.Entity(
  'notifications',
  {},
  { idAttribute: 'NotificationId' },
);

export const notificationListSchema = [notificationSchema];
